import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { SharedService } from "../../../../services/local/shared/shared.service";


@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  standalone: true,
})
export class LoaderComponent implements OnInit, OnDestroy {
  /**
   * Using array to handle situation where multiple methods starts their loader in a component
   * but the first ones output stop the loader (while others were still in process).
   */
  isLoaderVisible: any[] = [];
  showLoader$: any;
  loaderTimeout: any;
  loaderAutoTimeout: any;
  constructor(private sharedSrvc: SharedService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.showLoader();
  }
  showLoader() {
    this.showLoader$ = this.sharedSrvc.showLoader.subscribe((show: boolean) => {
      if (show) {
        if (!this.isLoaderVisible.length) {
          this.spinner.show();
          this.startRefreshTimeout();
        }
        this.isLoaderVisible.push('show');
      } else {
        this.isLoaderVisible.pop();
        if (!this.isLoaderVisible.length) {
          this.spinner.hide();
          if (this.loaderTimeout) {
            clearTimeout(this.loaderTimeout);
          }
          if (this.loaderTimeout) {
            clearTimeout(this.loaderAutoTimeout);
          }
          this.sharedSrvc.showRefreshButton.next(false);
        }
      }
    });
  }

  /**
   * Description: Method to show Refresh button under Loader in case API call
   * is taking more than than 15 seconds or to Auto refresh page if its taking more than 1 minute.
   */
  startRefreshTimeout(): void {
    this.loaderTimeout = setTimeout(() => {
      this.sharedSrvc.showRefreshButton.next(true);
    }, 15000);
    this.loaderAutoTimeout = setTimeout(() => {
      window.location.reload();
    }, 60000);
  }

  ngOnDestroy(): void {
    this.showLoader$.unsubscribe();
    if (this.loaderTimeout) {
      clearTimeout(this.loaderTimeout);
    }
    if (this.loaderAutoTimeout) {
      clearTimeout(this.loaderAutoTimeout);
    }
  }
}
